import React, { Component } from "react";
import moment from "moment";

import Loading from "../Common/Loading";
import RecentInstagram from "./RecentInstagram";

const getFullDayName = day => {
  const days = {
    mon: "Monday",
    tue: "Tuesday",
    wed: "Wednesday",
    thu: "Thursday",
    fri: "Friday",
    sat: "Saturday",
    sun: "Sunday"
  };
  return days[day] || "";
};

export default class Info extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sortedData: []
    };
  }
  componentDidMount() {
    const sortedData = this.getSortedData();
    this.setState({
      sortedData
    });
  }
  getSortedData = () => {
    const { openingHours } = this.props;
    const today = moment().format("dddd");
    const todayWeekDay = moment().isoWeekday();
    const openingHoursData = [];

    const sorter = {
      monday: 1,
      tuesday: 2,
      wednesday: 3,
      thursday: 4,
      friday: 5,
      saturday: 6,
      sunday: 7
    };
    for (let day in openingHours) {
      const formatStartDate = `July 21, 1983 ${openingHours[day].start_time}`;
      const formatEndDate = `July 21, 1983 ${openingHours[day].end_time}`;
      let openingHoursObject = {
        name: getFullDayName(day),
        today:
          today.toLocaleLowerCase() === getFullDayName(day).toLocaleLowerCase(),
        weekday: sorter[getFullDayName(day).toLowerCase()],
        start: moment
          .utc(formatStartDate)
          .local()
          .format("HH:mm:ss")
          .slice(0, 5),
        end: moment
          .utc(formatEndDate)
          .local()
          .format("HH:mm:ss")
          .slice(0, 5)
      };

      openingHoursData.push(openingHoursObject);
    }
    let sortedData = [];

    openingHoursData
      .sort(function sortByDay(a, b) {
        let day1 = a.name.toLowerCase();
        let day2 = b.name.toLowerCase();
        return sorter[day1] - sorter[day2];
      })
      .forEach(data => {
        let index;
        if (data.weekday < todayWeekDay) {
          index = (todayWeekDay - 7 - data.weekday) * -1;
          sortedData[index] = data;
        } else if (todayWeekDay === data.weekday) {
          sortedData[0] = data;
        } else {
          index = data.weekday - todayWeekDay;
          sortedData[index] = data;
        }
      });

    return sortedData;
  };
  render() {
    const {
      closedStatus,
      info,
      restaurantName,
      onCloseInfo,
      restaurantUid,
      isMobile
    } = this.props;
    const { sortedData } = this.state;
    return (
      (sortedData.length &&
        ((closedStatus && (
          <React.Fragment>
            {/* Header */}
            <div className="head-general with-back visible-xs">
              <a onClick={onCloseInfo} className="back">
                <img src="/png/chevron-left.png" />
              </a>
              <h4>Opening Hours</h4>
              <a className="close" />
            </div>
            {/* Header */}
            <div className="restaurant-info">
              <div className="white-bg mt-10px title-box body">
                <h5>Opening Hours</h5>
                <ul>
                  {sortedData &&
                    sortedData.length &&
                    sortedData.map((day, i) => (
                      <li key={i} className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                          {(i === 0 && (
                            <icon className="icon icon-clock" />
                          )) || <noscript />}
                          <p>{day.name}</p>
                        </div>
                        <p>
                          {day.start}-{day.end}
                        </p>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </React.Fragment>
        )) || (
          <React.Fragment>
            {/* Header */}
            <div className="head-general with-back visible-xs">
              <a
                href="javascript: void(0)"
                onClick={onCloseInfo}
                className="back"
              >
                <img src="/png/chevron-left.png" />
              </a>
              <h4>About {restaurantName}</h4>
              <a href="javascript: void(0)" className="close" />
            </div>
            {/* Header */}
            <div className="restaurant-info">
              {(info && (
                <div className="white-bg mt-10px title-box head">
                  <h5>Our Story</h5>
                  <p>{info}</p>
                </div>
              )) || <noscript />}
              <div className="white-bg mt-10px title-box body">
                <h5>Opening Hours</h5>
                <ul>
                  {(sortedData &&
                    sortedData.length &&
                    sortedData.map((day, i) => (
                      <li key={i} className="d-flex align-items-center">
                        <div className="d-flex align-items-center">
                          {(i === 0 && (
                            <icon className="icon icon-clock" />
                          )) || <noscript />}
                          <p>{day.name}</p>
                        </div>
                        <p>
                          {day.start}-{day.end}
                        </p>
                      </li>
                    ))) || <noscript />}
                </ul>
              </div>
              <RecentInstagram
                isMobile={isMobile}
                restaurantUid={restaurantUid}
              />
            </div>
          </React.Fragment>
        ))) || <Loading />
    );
  }
}
